import React from 'react'
import './FloorPlanSummaryReport.scss'
import PropTypes from 'prop-types'
import Comps from '@engine/comps'
import { connect } from 'react-redux'
import { formatNumber } from '@engine/utils/format'
import { EditButtonWrapper, PageTitleBar } from '@components/common'
import { EditPropertyDetails } from '../EditPropertyDetails/EditPropertyDetails'
import { floorPlanSummary } from '@engine/dependencies/constants'
export class FloorPlanSummaryReport extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isDialogOpen: false
    }
  }

  formatValue(col, value) {
    if (col.value === 'propertyAddress' && !value) {
      return ''
    }
    if (col.key === 'State' && value === undefined) {
      return 'NA'
    }
    const result = formatNumber(col.value, value)

    return result
  }

  handleDoneDialog = data => {
    const { fpSummaryTableColumns, type } = this.props
    const floorPlanType = Object.keys(fpSummaryTableColumns).find(key => key.includes(type))
    fpSummaryTableColumns[floorPlanType] = data.propertyFields
    this.props.editPropertyDetails({ type: 'floor', data: fpSummaryTableColumns, disclaimerTextData: data.disclaimerTextData })
  }

  handleEditButtonClick = () => {
    this.setState({
      isDialogOpen: !this.state.isDialogOpen
    })
  }

  render() {
    const { summarydata, hasBranding, hasPageTitle, themeColors, fpSummaryTableColumns, pageTitle, templateName, type } = this.props
    const dialogProperties = floorPlanSummary
    const floorPlanType = Object.keys(fpSummaryTableColumns).find(key => key.includes(type))
    dialogProperties.propertyFields = fpSummaryTableColumns[floorPlanType]
    const contentNote = 'Select none to hide labels. To change the column order, drag and drop a field'
    const dialogTitle = 'Property Summary'

    const columns_to_be_displayed = fpSummaryTableColumns[floorPlanType].filter(col => col.key !== 'NA')
    columns_to_be_displayed.unshift({ key: '', value: 'propertyType' })

    const page_header = pageTitle

    const cmp_props =
      summarydata &&
      summarydata.map(property => {
        const values = Object.keys(property).reduce((propObj, col) => {
          if (
            columns_to_be_displayed.some(
              colHeader => colHeader.value === col
            )
          ) {
            propObj[col] = property[col]
          }

          return propObj
        }, {})

        return values
      })

    const summaryTableLastRow = {
      propertyType: '',
      name: 'Total / Averages',
      builtPerRenovated: ''
    }

    if (cmp_props && cmp_props.length > 2) {
      for (const key in summaryTableLastRow) {
        if (summaryTableLastRow.hasOwnProperty(key)) {
          cmp_props[cmp_props.length - 1][key] = summaryTableLastRow[key]
        }
      }
    }

    const subjectPropMarkerStyle = {
      backgroundColor: themeColors.summarySubjectBackgroundColor,
      color: themeColors.summarySubjectTextColor,
      borderColor: themeColors.summarySubjectBorderColor,
      // fontFamily: '\'Montserrat\', sans-serif',
      fontFamily: '\'DIN Pro Light\'',
      fontSize: '10px'
    }

    const subjectRowBackgroundStyle = {
      backgroundColor: themeColors.summaryRowBackgroundColor
    }

    const comparablePropMarkerStyle = {
      backgroundColor: themeColors.summaryComparableBackgroundColor,
      color: themeColors.summaryComparableTextColor,
      border: `1px solid ${themeColors.summaryComparableBorderColor}`,
      // fontFamily: '\'Montserrat\', sans-serif',
      fontFamily: '\'DIN Pro Light\'',
      fontWeight: '500',
      fontSize: '10px'
    }

    return (
      <>
        <div data-testid="fp-summary-report" className={`${(hasPageTitle || hasBranding) ? 'fp-summary-report-view' : 'no-margin-fp-summary-report-view'}`}>
          <PageTitleBar templateName={templateName} hasPageTitle={hasPageTitle} hasBranding={hasBranding} themeColors={themeColors} />
          <div>
            <h1 data-testid="fp-sdummary-title" className="header-text-uppercase fp-page-title">
              {hasPageTitle && page_header}
            </h1>
          </div>
          <div data-testid="fp-summuary-table" className="fp-summary-table">
            <EditButtonWrapper handleEditButtonClick={this.handleEditButtonClick} dataTestId="fp-edit-summary-report-button">
              <table>
                <tbody>
                  <tr>
                    {columns_to_be_displayed.map((column, index) => (
                      <th key={index} className={column.key}>{column.key}</th>
                    ))}
                  </tr>
                  {cmp_props &&
                    cmp_props.map((row, i) => (
                      <tr key={i} style={row.propertyType.toString().includes('S') ? subjectRowBackgroundStyle : {}}>
                        {columns_to_be_displayed.map((col, j) => (
                          <td key={j}>
                            {col.value === 'propertyType' ? (
                              row.propertyType.toString().includes('S') ? (
                                <div className="tableindex_subject" style={subjectPropMarkerStyle}>
                                  {this.formatValue(col, row[col.value])}
                                </div>
                              ) : i === cmp_props.length - 1 ? (
                                <span>{this.formatValue(col, row[col.value])}</span>
                              ) : (
                                    <div className="tableindex_value" style={comparablePropMarkerStyle}>
                                      {this.formatValue(col, row[col.value])}
                                    </div>
                                  )
                            ) : (
                                <span>{this.formatValue(col, row[col.value], i)}</span>
                              )}
                          </td>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </table>
            </EditButtonWrapper>
          </div>
        </div >
        {this.state.isDialogOpen ? (
          <EditPropertyDetails
            isDialogOpen={this.state.isDialogOpen}
            closeEditPopup={this.handleEditButtonClick}
            doneDialog={this.handleDoneDialog}
            contentNote={contentNote}
            dialogTitle={dialogTitle}
            dialogProperties={dialogProperties}
          />
        ) : ''}
      </>
    )
  }
}

FloorPlanSummaryReport.propTypes = {
  hasBranding: PropTypes.bool,
  hasPageTitle: PropTypes.bool,
  summarydata: PropTypes.array,
  themeColors: PropTypes.object,
  fpSummaryTableColumns: PropTypes.object,
  editPropertyDetails: PropTypes.func,
  templateName: PropTypes.string,
  pageTitle: PropTypes.string,
  type: PropTypes.string
}

const mapStateToProps = state => ({
  themeColors: Comps.selectors.comps.themeColors(state),
  fpSummaryTableColumns: Comps.selectors.comps.fpSummaryTableColumns(state),
  templateName: Comps.selectors.comps.templateName(state)
})

const mapDispatchToProps = {
  editPropertyDetails: Comps.actions.editPropertyDetails
}

export default connect(mapStateToProps, mapDispatchToProps)(FloorPlanSummaryReport)
